import Vue from 'vue'
import {
  GET_MEETINGS,
  GET_MEETINGS_FOR_CONTACT,
  GET_MEETINGS_FOR_PROJECT,
  ERROR_XHR,
  REQUEST_ADD_MEETING,
  SUCCESS_ADD_MEETING,
  REQUEST_UPDATE_MEETING,
  SUCCESS_UPDATE_MEETING,
  REQUEST_DELETE_MEETING,
  SUCCESS_DELETE_MEETING,
  GET_MEETING,
  SELECT_DAY,
  SELECT_CALENDAR_USERS,
  TOGGLE_CALENDAR_USER
} from '../mutation-types.js'

// import { getUsers } from 'src/vuex/actions/userActions'
import { SELECTED_USERS_STORAGE_KEY } from 'src/vuex/store'

export const getSelectedUsers = (store) => {
  let localData = JSON.parse(window.localStorage.getItem(SELECTED_USERS_STORAGE_KEY)) || []
  // If we have something in local storage, use it
  if (localData.length) {
    console.log('getSelectedUsers localData ' + localData.length + ' ' + JSON.stringify(localData))
    return new Promise((resolve, reject) => {
      store.dispatch(SELECT_CALENDAR_USERS, localData)
      resolve()
    })
  }

  /*
  // Map users array, return only id's
  const sortUsers = (users) => users.map(user => user.id)
  // If users all is empty, launch getUsers action first
  if (!store.state.users.all.length) {
    return getUsers(store).then(() => store.dispatch(SELECT_CALENDAR_USERS, sortUsers(store.state.users.all)))
  }
  */
  // Map users array, return only id's
  console.log('getSelectedUsers ' + store.state.meetings.selectedUsers.length + ' ' + JSON.stringify(store.state.meetings.selectedUsers))
  if (store.state.meetings.selectedUsers.length > 0) {
    return new Promise((resolve, reject) => {
      store.dispatch(SELECT_CALENDAR_USERS, store.state.meetings.selectedUsers)
      resolve()
    })
  }

  // Else map array from users state
  return new Promise((resolve, reject) => {
    // store.dispatch(SELECT_CALENDAR_USERS, sortUsers(store.state.users.all))
    store.dispatch(SELECT_CALENDAR_USERS, [store.state.auth.user.id])
    resolve()
  })
}

export const toggleSelectedUser = ({ dispatch }, userId) => {
  dispatch(TOGGLE_CALENDAR_USER, userId)
}

export const getMeetings = ({ dispatch, state }, start, end) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('meeting', { params: { start, end, users: state.meetings.selectedUsers } })
      .then(
        (response) => {
          dispatch(GET_MEETINGS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

export const getMeetingsForContact = ({ dispatch, state }, start, end, contact) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('meeting/contact', { params: { start, end, contact } })
      .then(
        (response) => {
          // console.log(response)
          dispatch(GET_MEETINGS_FOR_CONTACT, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

export const getMeetingsForProject = ({ dispatch, state }, start, end, project) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('meeting/project', { params: { start, end, project } })
      .then(
        (response) => {
          // console.log(response)
          dispatch(GET_MEETINGS_FOR_PROJECT, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

export const getMeeting = ({ state, dispatch }, meetingId) => {
  const sortMeetings = (users, userId) => users.filter((user) => Number(user.id) === Number(userId))[0]
  return new Promise((resolve, reject) => {
    if (state.meetings.all.length) { // If meeting all is not empty, we look into it
      let meeting = sortMeetings(state.meetings.all, meetingId)
      dispatch(GET_MEETING, meeting)
      resolve(meeting)
    } else { // Else we ask the server
      Vue.http.get('meeting/' + meetingId)
      .then(
        response => {
          dispatch(GET_MEETING, response.json())
          resolve()
        }
      )
    }
  })
}

export const addMeeting = ({ dispatch }, meeting) => {
  dispatch(REQUEST_ADD_MEETING)
  return new Promise((resolve, reject) => {
    Vue.http
      .post('meeting', meeting)
      .then(
        (response) => {
          dispatch(SUCCESS_ADD_MEETING)
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

export const updateMeeting = ({ dispatch }, oldMeeting, newMeeting) => {
  dispatch(REQUEST_UPDATE_MEETING)
  Vue.http.put('meeting/' + oldMeeting.id, newMeeting)
    .then(response => {
      dispatch(SUCCESS_UPDATE_MEETING, response.json())
    })
}

export const deleteMeeting = ({ dispatch }, meeting) => {
  dispatch(REQUEST_DELETE_MEETING, meeting)
  Vue.http.delete('meeting/' + meeting.id)
    .then(response => dispatch(SUCCESS_DELETE_MEETING, meeting))
}

/**
 * Select current day to display
 */
export const selectDay = ({ dispatch }, day) => {
  dispatch(SELECT_DAY, day)
}



// WEBPACK FOOTER //
// ./src/vuex/actions/meetingActions.js